import { render, staticRenderFns } from "./homeGdAdd.vue?vue&type=template&id=789f67ce&scoped=true&"
import script from "./homeGdAdd.vue?vue&type=script&lang=js&"
export * from "./homeGdAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789f67ce",
  null
  
)

export default component.exports